var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{ref:"icon",staticClass:"icon",class:[_vm.rotationClass, {flipX: _vm.flipX, flipY: _vm.flipY}]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }